import React, {FunctionComponent} from "react";

export type CircleStepProps = {
    step: number;
};

const CircleStep: FunctionComponent<CircleStepProps> = ({step}) => {
    return (
        <span className="circle-step">{step}</span>
    );
};

export default CircleStep;
